import { getCookie } from 'utils/getCookie';

const getFirstPromoterReferralId = () => getCookie('_fprom_tid', null);

export default getFirstPromoterReferralId;
